<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('business_hours') }}
        v-card-text.pa-4
          div.d-flex.align-center
            div.s1.primary--text {{ $t('enable_business_hour') }}
            v-spacer
            div
              y-switch.mb-n3(v-model="bhEnabled")
          div(v-show="bhEnabled")
            v-divider.basic300.my-3
            y-checkbox.my-auto.mx-0.pa-0(v-model="bhCheckout")
              template(v-slot:label)
                div.p1.my-auto(:class="checkPaymentCheckout || 'danger--text'") {{ $t('disable_checkout') }}
            y-checkbox.my-auto.mx-0.pa-0.mt-2(v-model="bhPayment")
              template(v-slot:label)
                div.p1.my-auto(:class="checkPaymentCheckout || 'danger--text'") {{ $t('disable_payment') }}
            v-divider.basic300.my-3
            v-form(ref="form")
              template(v-for="(day, index) in timetable")
                div.d-flex.align-center.mt-5(:key="day.name")
                  div.s1.primary--text.text-capitalize {{ day.name }}
                  v-spacer
                  v-btn.button-AA-small.px-3(color="textColorAccent" outlined small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}"  @click="day.slots.push({ open: null, shut: null })")
                    v-icon(left small) mdi-plus
                    | {{ $t('add_slot') }}
                template(v-for="(slot, idx) in day.slots")
                  v-row.mt-3(no-gutters :key="day.name + idx")
                    v-col.pr-2
                      div.label.basic600--text.text-uppercase {{ $t('open') }}
                      v-text-field.mt-2(v-model="slot.open" placeholder="Open hour" background-color="basic200" height="40" outlined dense hide-details type="time" :rules="rules.not_empty")
                    v-col.px-2
                      div.label.basic600--text.text-uppercase {{ $t('close') }}
                      v-text-field.mt-2(v-model="slot.shut" placeholder="Close hour" background-color="basic200" height="40" outlined dense hide-details type="time" :rules="rules.not_empty")
                    v-col.shrink
                      v-btn.button-Aa-small.custom-transform-class.text-none.px-0.mt-7(color="danger500" icon small @click="day.slots.splice(idx, 1)")
                        eva-icon(name="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" height="20" width="20")
            v-divider.basic300.my-4
            div.s1.primary--text.text-capitalize.mb-2 {{ $t('holidays') }}
            v-date-picker(v-model="holidays" multiple full-width no-title first-day-of-week="1")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='info500' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'
import ColorPicker from '@/components/ColorPicker.vue'
export default {
  name: 'AddBusinessHour',
  components: { ColorPicker },
  props: ['open', 'settings', 'company'],
  data: () => ({
    bhEnabled: false,
    bhPayment: true,
    bhCheckout: true,
    timetable: [
      { name: 'monday', slots: [] },
      { name: 'tuesday', slots: [] },
      { name: 'wednesday', slots: [] },
      { name: 'thursday', slots: [] },
      { name: 'friday', slots: [] },
      { name: 'saturday', slots: [] },
      { name: 'sunday', slots: [] }
    ],
    holidays: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
    isLoading: false
  }),
  watch: {
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    status () {
      return this.bannerStatus ? 'published' : 'draft'
    },
    checkPaymentCheckout () {
      if (!this.bhCheckout && !this.bhPayment) {
        return false
      }
      return true
    }
  },
  mounted () {
    if (this.settings.business_hours) {
      this.bhEnabled = this.settings.business_hours.enabled
      this.bhCheckout = this.settings.business_hours.disable_checkout
      this.bhPayment = this.settings.business_hours.disable_payment
      this.timetable = this.settings.business_hours.timetable
      this.holidays = this.settings.business_hours.holidays
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.checkPaymentCheckout && this.bhEnabled) {
        this.showMessage(['error', this.$t('error_message.checkout_payment_field_required')])
        return
      }
      this.isLoading = true
      let data ={
        enabled: this.bhEnabled,
        disable_checkout: this.bhCheckout,
        disable_payment: this.bhPayment,
        timetable: this.timetable,
        holidays: this.holidays
      }
      this.$axios.patch(`/store/settings/${this.company.slug}/`, { business_hours: data })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.business_hour_updated')])
          this.$emit('bhour', data)
          this.showModal = false
        })
        .catch((err) =>{
          if (err.response.data.business_hours && err.response.data.business_hours.length > 0) {
            this.showMessage(['error', err.response.data.business_hours[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>
